module.exports = __webpack_public_path__ + "media/images/pic/materials-01dff64ca4e377143c4d44d8e684eb98.svg";